---
title: "Privacy Policy"
effectiveDate: "2026-02-06"
lastUpdated: "2026-02-06"
---

## Summary

- We treat user data as liability and design key.store to collect as little as possible.
- We do not sell personal information.
- We use your information to operate the service, keep it secure, and improve it.
- If you contact us, we use your message to respond and to fix issues.

## Information We Collect

This policy covers the key.store website, apps, and related services operated by `key dot store, LLC` (collectively, the "Service").

Depending on how you use the Service, we may collect:

- **Information you provide.**
  - Feedback and support requests you submit through our forms (including any contact email you provide).
  - Any information you include in the body of your message.
- **Service and device information.**
  - Approximate device and browser details (for example: OS version, browser type, screen size).
  - Basic usage and performance signals needed to keep the Service reliable.
- **Log and security data.**
  - IP address, timestamps, request paths, and similar log data used to operate and defend the Service (for example: abuse prevention, rate limiting, incident response).
- **Cookies and local storage.**
  - We may use strictly-necessary cookies or local storage for core site functionality (for example: routing, preferences).
  - We do not run third-party advertising trackers on key.store pages.

## Passwords and Vault Data

If you use key.store apps, the Service may process and store encrypted authentication data to sync it between your devices.
We design the Service to avoid collecting plaintext secrets, but the exact data we process depends on product configuration and may change as we ship new features.

## How We Use Information

We use information we collect to:

- Provide, operate, and maintain the Service.
- Detect, prevent, and respond to abuse, fraud, and security incidents.
- Improve the Service (including performance and reliability).
- Communicate with you about your requests (for example: responding to feedback submissions).

## How We Share Information

We share information only when necessary:

- **Service providers and infrastructure.** We may share information with vendors who help us run the Service (for example: hosting, email delivery). They are permitted to process information only to provide services to us.
- **Legal and safety.** We may disclose information if required by law, or if we believe disclosure is reasonably necessary to protect the rights, safety, and security of users, the public, or key.store.
- **With your direction.** We may share information when you ask us to or when you consent.

We do not sell personal information.

## Data Retention

We retain information for as long as needed to operate the Service, meet legal and security requirements, and resolve disputes.

We aim to minimize retention and delete or de-identify information when it is no longer needed.

## Your Choices and Rights

Depending on where you live, you may have rights to access, correct, or delete your personal information, and to object to or restrict certain processing.

To exercise these rights, contact us at `privacy@key.store`.

## Children

The Service is not directed to children. If you believe a child has provided personal information to us, contact `privacy@key.store`.

## Changes

If we make material changes to this policy, we will update the "last updated" date and post the revised policy on this page.

## Contact

For privacy questions, contact `privacy@key.store`.
